import { Employee } from '../api'
import { EmployeeV2 } from '../api-v2'
import { ApiVersionDelagator } from './api-delegator'

/**
 * @typedef {import('../api-v2/js-doc').V1Employee} V1Employee
 * @typedef {import('../api-v2/js-doc').V2CreateEmployee} V2CreateEmployee
 * @typedef {import('../api-v2/js-doc').V2MappingOptions} V2MappingOptions
 */

export class EmployeeApiDelegator extends ApiVersionDelagator {
  /**
   * @param {V1Employee} v1Request
   * @returns {Promise<V1Employee>}
   */
  async createEmployee(v1Request) {
    return await this.runWriteApiCalls(
      undefined, 
      v1Request,
      this.#createEmployeeV1,
      this.#createEmployeeV2,
      {
        operationName: 'create-employee',
      }
    )
  }

  /**
   * @param {V1Employee} v1Request
   * @returns {Promise<V1Employee>}
   */
  async #createEmployeeV1(v1Request) {
    return (await Employee.create(v1Request)).data
  }

  /**
   * @param {V2MappingOptions} v2MappingOptions 
   * @param {V1Employee} v1Request
   * @param {V1Employee=} v1Response
   * @returns {Promise<V1Employee>}
   */
  async #createEmployeeV2(v2MappingOptions, v1Request, _v1Response) {
    const v2Request = {
      __v1Payload: v1Request,
      __ingestThrough: v2MappingOptions.ingestThrough,
      email: v1Request.email,
      extension: v1Request.extension,
      firstName: v1Request.first_name,
      lastName: v1Request.last_name,
      role: v1Request.role.toLowerCase().replace(' ', '_'),
    }
    const result = await new EmployeeV2().create(v2Request)
    return result 
  }
}